import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getCities } from "./Axios";

const CitySelect = props => {
  const [cities, setCities] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "city");
  };

  useEffect(() => {
    getCities((response) => {
      if (response && response.data) {
        const newCities = response.data.map((city) => ({
          value: city.id,
          label: city.name,
          uniqueIdentifier: city.unique_identifier,
        }));
        setCities(newCities);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-city-search"
      onChange={handleChange}
      options={cities}
      placeholder="Buscar y seleccionar una comuna"
      value={
        cities.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default CitySelect;

